/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// const profotoProducts = new Set([
//   90020010, 90040010, 90010010, 90030010, 90050010, 80111030,
// ]);

/**
 * Profoto Mutation Observer
 * @author @ayodyln
 * @version 1.0
 * @description This script is used to observe the changes in the Klevu search results and Hides the Profoto Products from the Search Element.
 */
// function observeKlevuSearchResults() {
//   const klevuElement = document.querySelector(".klevuSearchResults-l2"); // Klevu Search Results Element
//   if (!klevuElement) {
//     setTimeout(observeKlevuSearchResults, 1000); // Retry after 1 second
//     return;
//   }
//   const config = { attributes: false, childList: true, subtree: true };
//   const observer = new MutationObserver((mutationsList, observer) => {
//     for (const mutation of mutationsList) {
//       if (mutation.type === "childList") {
//         // Loop through added nodes in the mutation
//         mutation.addedNodes.forEach((node) => {
//           node.childNodes.forEach((child) => {
//             const description = child.querySelector(
//               ".klevu-name-desc-l2 > .klevu-name-l2 > span"
//             );
//             const price = child.querySelector(
//               ".klevu-name-desc-l2 > .klevu-price-l2"
//             );
//             const sku = parseInt(description.textContent.replace(/[()]/g, ""));
//             const isProfotoProduct = profotoProducts.has(sku);
//             if (isProfotoProduct) {
//               price.remove();
//             }
//           });
//         });
//       }
//     }
//   });
//   observer.observe(klevuElement, config);
// }

/**
 * Klevu Search Results Observer
 * @author @ayodyln
 * @version 1.0
 * @description This script is used to observe the Klevu Search Results Page and log the current URL.
 */
// function klevuSearchResultsObserver() {
//   if (window.location.pathname !== "/pages/search-results") return;

//   const filters = document.querySelector(".kuFilters");
//   const resultsView = document.getElementById("kuResultsView");

//   if (resultsView && filters) {
//     const config = { attributes: false, childList: true, subtree: false };

//     const observer = new MutationObserver((mutationsList, observer) => {
//       const rangefilter = document.querySelector("#kuFilterBox-Price-Range");
//       const searchContainsProfoto = /\b(profoto|styleshoots|product)\b/.test(
//         window.location.search.toLowerCase()
//       );

//       if (searchContainsProfoto) {
//         rangefilter.remove();
//       }

//       for (const mutation of mutationsList) {
//         if (mutation.type === "childList") {
//           mutation.addedNodes.forEach((node) =>
//             node.childNodes.forEach((child) => {
//               const kuNameDesc = parseInt(
//                 child
//                   .querySelector(".kuNameDesc > .kuName > a span")
//                   .textContent.replace(/[()]/g, "")
//               );

//               const price = child.querySelector(".kuPrice");
//               const isProfotoProduct = profotoProducts.has(kuNameDesc);
//               if (isProfotoProduct) {
//                 price.remove();
//               }
//             })
//           );

//           klevuULObserver(
//             observer,
//             mutation.addedNodes.entries().find((entry) => {
//               if (entry[1].tagName === "UL") return entry[1];
//             })
//           );
//         }
//       }
//     });

//     observer.observe(resultsView, config);
//   }
// }

/**
 * Klevu UL Observer
 * @description This function is used to observe the UL post DOM Content Loaded ~ List Items are added on Scroll
 * @param {MutationObserver} initialObserver - Initial Mutation Observer
 * @param {Array} ul - UL Element
 */
// function klevuULObserver(initialObserver, ul) {
//   initialObserver.disconnect();
//   const [_, node] = ul;
//   const config = { attributes: false, childList: true, subtree: true };
//   const observer = new MutationObserver((mutationsList, observer) => {
//     for (const mutation of mutationsList) {
//       if (mutation.type === "childList") {
//         mutation.addedNodes.forEach((node) => {
//           const kuNameDesc = parseInt(
//             node
//               .querySelector(".kuNameDesc > .kuName > a > span")
//               .textContent.replace(/[()]/g, "")
//           );
//           const price = node.querySelector(".kuPrice");
//           const isProfotoProduct = profotoProducts.has(kuNameDesc);
//           if (isProfotoProduct) price?.remove();
//         });
//       }
//     }
//   });
//   observer.observe(node, config);
// }

// Wait for the DOM to be ready
// document.addEventListener("DOMContentLoaded", () => {
//   observeKlevuSearchResults(); // Start observing the Klevu Search Results
//   klevuSearchResultsObserver(); // Start observing the Klevu Search Results Page
// });

/**
 * Location Stock Availability Handler
 * Updates location stock display when variant changes on product page
 */
(function() {
  'use strict';

  function updateLocationStock(variantId) {
    const locationStockContainer = document.querySelector('.location-stock-availability[data-variant-id="' + variantId + '"]');
    
    if (!locationStockContainer) {
      // If container doesn't exist for this variant, fetch it from the server
      fetch(window.Shopify.routes.root + 'variants/' + variantId + '?section_id=store-availability')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newLocationStock = doc.querySelector('.location-stock-availability');
          
          if (newLocationStock) {
            // Only update collection page location stock, not product page (product page renders it inline with stock status)
            const existingContainer = document.querySelector('.product-item__location-stock');
            if (existingContainer) {
              existingContainer.innerHTML = newLocationStock.outerHTML;
            }
            // Don't update product-meta__location-stock as it's no longer used on product pages
          }
        })
        .catch(error => {
          console.error('Error updating location stock:', error);
        });
    }
  }

  // Listen for variant changes
  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant;
    if (variant && variant.id) {
      updateLocationStock(variant.id);
    }
  });

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    // The modal functionality is already handled by theme.js via data-action attributes
    // No additional initialization needed
  });
})();
